const definitions = {
  isTestFeatureEnabled: false,
};

export default definitions;
